define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/datasheet/Preferences",
	"csi/datasheet/Widget",
	"csi/state",
	"ProductSpec/SizeChart/SizeChartDataSheetOptionsTab",
	"ProductSpec/SizeChart/SizeChartDataSheetCustomViewOptionsStore",
], function(declare, _, Preferences, DataSheetWidget, state, SizeChartDataSheetOptionsTab, SizeChartDataSheetCustomViewOptionsStore) {

	var _Preferences = declare(Preferences, {
		constructor: function() {
			this.addCustomOption("sizeChartPrintSubSizeRanges", false, false, "SizeChartPrintSubSizeRanges");
		}
	});

	return declare(DataSheetWidget, {
		customViewOptionsComponent: SizeChartDataSheetOptionsTab,
		customViewOptionsStore: SizeChartDataSheetCustomViewOptionsStore,
		prefClass: _Preferences,
		sizeChartPrintSubSizeRanges: false,

		_getRootRequest: function(/*Node*/node) {
			// summary: add sub size ranges as dependency path when printing
			var req = this.inherited(arguments);

			if (state.get("print")) {
				req.addDependencyPaths(["Child:SizeChartSubSizeRanges"]);
			}

			return req;
		},

		_processKey: function(/*Context*/ctx, /*String*/key, /*Object*/def, /*DOMNode*/domNode) {
			// summary: render definition in context for element
			if (ctx.bPrint && this.sizeChartPrintSubSizeRanges && (key == "Dimensions")) {
				var subSizeRanges = ctx.cache.getNodes(ctx.getNode().SizeChartSubSizeRanges);
				if (subSizeRanges.length > 1) {
					var params = _.map(subSizeRanges, function(sr) {
						return {
							secondaryViewId: sr.$URL,
							urlSubSizeRange: sr.$URL
						};
					});

					var labels = _.map(subSizeRanges, function(sr) {
						return sr.$Name;
					});

					this._processViewRefForEach(ctx, def, domNode, params, labels);
					return null;
				}
			}

			return this.inherited(arguments);
		}
	});
});